import { useNavigate } from "react-router-dom";
import PageHeader from "../../pageheader/PageHeader";
import Breadcrumb from "../breacrumb/breadcrumb";

function Information({ type, role }) {
  const navigate = useNavigate();
  const presetTailwind = {
    btnMenu:
      "transition transform hover:-translate-y-4 duration-[400ms] motion-reduce:transition-none motion-reduce:hover:transform-none md:h-[200px] h-[300px] w-[300px] border border-[#A2B5BC] rounded-2xl ",
  };

  const pathItems = [
    { name: "หน้าหลัก", url: `${role ?? ""}/` },
    { name: "ข้อมูลที่เกี่ยวข้อง", url: `${role ?? ""}/information` },
  ];
  return (
    <div className="global-page">
      <Breadcrumb pathItems={pathItems} />
      <PageHeader titlename={"ข้อมูลที่เกี่ยวข้อง"} />
      <div className="flex justify-center w-full mt-[5rem] md:mt-[3rem]">
        <div className="flex md:flex-col flex-wrap gap-16 2xl:gap-28 xl:gap-16 lg:gap-12">
          <button
            onClick={() => {
              navigate(
                `${
                  role && (!type || !type.startsWith(role)) ? `/${role}` : ""
                }mapoperationRoom`,
                { state: { type } },
              );
            }}
            className={presetTailwind.btnMenu}
          >
            <div className="w-full flex justify-center mb-6">
              <img
                className="h-[200px]  md:h-[120px]"
                src="/images/information-img.svg"
                alt=""
              />
            </div>
            <div className="text-md text-[#000000]">
              แผนที่ห้องปฏิบัติการที่มีข้อมูลในระบบ
            </div>
          </button>
          <button
            onClick={() => {
              navigate(
                `${
                  role && (!type || !type.startsWith(role)) ? `/${role}` : ""
                }pharmacogeneticTest`,
                { state: { type } },
              );
            }}
            className={presetTailwind.btnMenu}
          >
            <div className="w-full flex justify-center mb-6">
              <img
                className="h-[200px]  md:h-[120px]"
                src="/images/right_home_public.svg"
                alt=""
              />
            </div>
            <div className="text-md text-[#000000]">
              การตรวจทางเภสัชพันธุศาสตร์
            </div>
          </button>
          <button
            onClick={() => {
              navigate(
                `${
                  role && (!type || !type.startsWith(role)) ? `/${role}` : ""
                }form_survey`,
                { state: { type } },
              );
            }}
            className={presetTailwind.btnMenu}
          >
            <div className="w-full flex justify-center mb-6">
              <img
                className="h-[200px]  md:h-[120px]"
                src="/images/form_survey.svg"
                alt=""
              />
            </div>
            <div className="text-md text-[#000000]">
              แบบฟอร์มส่งตรวจเภสัชพันธุศาสตร์
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Information;
